<template>
    <div class="cst-survey-feedback-topic">
        <h1>{{ $t('topicTitle') }}</h1>
        <h2>{{ $t('topicHint') }}</h2>
        <div class="cst-survey-feedback-topics">
            <div v-bind:key="topic.id" @click="setTopic(topic)" class="feedback-topic" v-for="topic in availableTopics"><span class="name" v-html="topic.name"></span>
                <span v-if="hasContent(topic)" class="filled-topic"><topic-bubble></topic-bubble></span>
            </div>
        </div>
        <a class="btn-back" @click="back"><arrow-left></arrow-left></a>
        <a class="btn-close" @click="close"><btn-cancel></btn-cancel></a>
    </div>    
</template>

<script>
    /* global eventHub */
    /* eslint no-undef: "error" */
    import TopicBubble from './TopicBubble'
    import ArrowLeft from './ArrowLeft'
    import BtnCancel from './BtnCancel'

    export default {
      props: [ 'content' ],
      data: function () {
        return {}
      },
      created: function () {
      },
      methods: {
        close: () => {
          eventHub.$emit('close-modal')
        },
        back: function () {
          let c = this.$store.state.cards[this.$store.state.current_card_position].content
          eventHub.$emit('show-modal', {type: 'card-feedback-comment', id: 7, content: { title: c.group_title, group_id: c.group_id }})
        },
        setTopic: function (questionGroup) {
          eventHub.$emit('show-modal', {type: 'card-feedback-comment', id: 8, content: { title: questionGroup.title, group_id: questionGroup.id }})
        },
        hasContent: function (topic) {
          return !!this.$store.state.reviews[topic.id * 1]
        }
      },
      computed: {
        availableTopics: function () {
          let availableTopics = []
          for (var x in this.$store.state.questionaire.question_groups) {
            let group = this.$store.state.questionaire.question_groups[x]
            if (group.review * 1) {
              availableTopics.push(group)
            }
          }
          return availableTopics
        }
      },
      components: {
        TopicBubble, ArrowLeft, BtnCancel
      }
    }
</script>

<style lang="less" scoped>
    @import '../_theme';

    .cst-survey-feedback-topics {
        display: flex;
        flex-wrap: wrap;
        align-items: stretch;
    }
    .feedback-topic {
        cursor: pointer;
        border: 1px solid @border-color;
        flex: 0 0 32%;
        margin: 0.2em;
        padding: 0.5em;
        box-sizing: border-box;
        display: flex;
        align-items: center;
        justify-content: space-between;
        max-width: 48%;
    }
    .feedback-topic:hover {
        border: 1px solid @main-button-color;
        background-color: @item-active-color;
    }
    .filled-topic {
        display: block;
        align-items: center;
        width: 2em;
        height: 1.5em;        
    }
    .cst-survey-feedback-topic {
      position: relative;
      padding: 0.5em;
    }

    .btn-close {
      .btn-close
      
    } 
    .btn-back {
      cursor: pointer;
      position: absolute;
      top: 1em;
      left: 1em;
      display: block;
      color: @main-button-color;
      width: 1.5em;
      height: 1.5em;
      svg {
          width: 1.5em;
          height: 1.5em;
      }
    }   
    .name {
      display: block;
    }
    @media (max-width: 1200px) { 
     .feedback-topic {
        flex: 0 0 48%;     
     }
    }

    @media (max-width: 800px) {   
      .btn-back, .btn-close, .btn-close svg {
        width: 1.5em;
        height: 1.5em;
      }
    }


</style>


// WEBPACK FOOTER //
// src/components/CardFeedbackTopic.vue